import { Switch } from '@material-ui/core'
import styled from 'styled-components'
import { Colors, Typography } from 'styles'
import { ReactComponent as SpotifyLogoSvg } from '../../assets/icons/spotifyLogo.svg'

export const Container = styled.div`
  width: 100%;
  border: 1px solid ${Colors.BLACK};
  border-radius: 40px;
  padding: 20px 28px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;

  @media (max-width: 400px) {
    flex-wrap: wrap;
  }
`

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid ${Colors.BLACK};
`

export const IntegrationInfoText = styled.p`
  font-weight: 300;
  font-size: 1rem;
  color: ${Colors.GREY[400]};
  font-family: Inter;
  letter-spacing: -${Typography.LETTER_SPACING_1}px;
  margin: 0;
`

export const InfoContainer = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
`

export const InfoText = styled.p`
  font-weight: 300;
  font-size: 1.2rem;
  color: ${Colors.GREY[400]};
  font-family: Inter;
  letter-spacing: -${Typography.LETTER_SPACING_1}px;
  text-align: center;
  margin: 0;
`

export const StyledSwitch = styled(Switch).attrs({ size: 'medium' })`
  scale: 1.3;

  & .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
    background-color: ${Colors.PURPLE[400]};
  }

  & .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb {
    background-color: ${Colors.PURPLE[400]};
  }
`

export const SpotifyLogo = styled(SpotifyLogoSvg)`
  width: 56px;
  height: 56px;
`

export const TextContainer = styled.div`
  display: flex;
  gap: 6px;
  flex-direction: column;
  flex-grow: 1;
`

export const Title = styled.p`
  font-weight: 800;
  font-size: 1.2rem;
  color: ${Colors.GREY[400]};
  font-family: Inter;
  letter-spacing: -${Typography.LETTER_SPACING_1}px;
  margin: 0;
`

export const Description = styled.p`
  font-weight: 300;
  font-size: 1rem;
  color: ${Colors.GREY[300]};
  font-family: Inter;
  letter-spacing: -${Typography.LETTER_SPACING_1}px;
  margin: 0;
`

export const AboutLink = styled.a`
  cursor: pointer;
  text-decoration: underline;
  color: ${Colors.PURPLE[400]};
`

export const DeactivateModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 16px;
`

export const DeactivateModalText = styled.p`
  margin: 0;
`

export const DeactivateModalActions = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
`
